import classNames from 'classnames'
import { ActionMeta } from 'react-select'

import { Option } from './types'
import { getDefaultValueSafely, getOnChangeFunctionSafely } from './utils'
import { FieldLabel } from '@/Atomic/Atoms/FieldLabel'
import { Icon } from '@/Atomic/Atoms/Icon'
import {
  BasicSelect,
  BasicSelectProps,
} from '@/Atomic/Atoms/Inputs/BasicSelect'

import '../FieldStates.scss'
import './Select.scss'

interface Select extends BasicSelectProps {
  name: string
  label?: string
  requirementState?: 'required' | 'optional'
  options?: Option[]
  value?: unknown
  defaultValue?: unknown
  onChange: (...event: unknown[]) => void
  isMulti?: boolean
  flash?: boolean
  className?: string
  error?: string
}

export const Select: React.FC<Select> = ({
  name,
  label,
  requirementState,
  options,
  value,
  defaultValue,
  onChange,
  isMulti,
  flash,
  className,
  isDisabled,
  error,
  ...props
}) => {
  const isControlled = value !== undefined
  const defValue = getDefaultValueSafely(
    isControlled ? value : defaultValue,
    options,
  )
  const onChangeFunction = (val: unknown, action: ActionMeta<unknown>) =>
    getOnChangeFunctionSafely(onChange, val, action)

  return (
    <div
      className={classNames(className, {
        'field--readonly': isDisabled,
        'field-invalid': error,
      })}
    >
      <FieldLabel
        name={name}
        label={label}
        requirementState={requirementState}
      />
      <BasicSelect
        name={name}
        {...(isControlled
          ? { value: defValue ?? null }
          : { defaultValue: defValue })}
        options={options}
        onChange={onChangeFunction}
        isClearable
        isMulti={isMulti}
        flash={flash}
        isDisabled={isDisabled}
        {...props}
      />
      {error && (
        <div className="field-error" role="alert">
          <Icon icon="info-circle" size="sm" />
          <span>{error}</span>
        </div>
      )}
    </div>
  )
}
